import { useEffect } from "react";

import { atom, useAtom } from "jotai";
import { useNavigate, useParams } from "react-router";

import PartyAss from "~/ass/party.json";
import RunningDogAss from "~/ass/running_dog.json";
import AnimatedSticker from "~/components/animated-stickers";
import QuestionCard from "~/components/question-card";
import { Button } from "~/components/ui/button";
import { useGetQuiz } from "~/lib/hooks/api.hooks";

export const isFinishedAtom = atom(false);

const QuizPage = () => {
  // REQUIRED AUTHENTICATION
  // useSession({ required: true });

  // PARAMS
  const { quiz_id } = useParams<{ quiz_id: string }>();

  // HOOKS
  const [isFinished, setIsFinished] = useAtom(isFinishedAtom);
  const navigate = useNavigate();

  // API HOOKS
  const quiz = useGetQuiz(quiz_id as string);

  useEffect(() => {
    return () => {
      setIsFinished(false);
    };
  }, []);

  if (quiz.isPending) {
    return (
      <AnimatedSticker
        data={{
          raw: RunningDogAss,
        }}
        title="Fetching the Quiz"
        desc="Loading the generated quiz"
      />
    );
  }

  return (
    <div className="my-auto p-4 sm:p-0">
      {!isFinished && quiz.data?.questions.length && (
        <QuestionCard
          phrase={quiz.data.phrase}
          questions={quiz.data.questions}
        />
      )}
      {isFinished && (
        <div className="flex flex-col gap-4 justify-center items-center">
          <AnimatedSticker
            title="Great Job!"
            desc="You've completed the quiz successfully. Check your results and keep improving!"
            data={{
              raw: PartyAss,
            }}
          />
          <Button className="mx-auto w-full" onClick={() => navigate("/app")}>
            New Phrase/Word
          </Button>
          <Button
            className="mx-auto w-full"
            variant="secondary"
            onClick={() => setIsFinished(false)}
          >
            Retry
          </Button>
        </div>
      )}
    </div>
  );
};
export default QuizPage;
